import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { Section, SectionHeader, SecondaryButton } from "@/components/Section";
import { SocialPlanCard } from "@/components/SocialPlanCard";
import { SEO } from "@/components/SEO";
import { packages } from "@/config/site";

export default function Packages() {
    return (
        <>
            <SEO title="Pakiety – Szymkas Agency" description="Pakiety Start, Rozwój i Skala – wybierz rozwiązanie dopasowane do etapu rozwoju Twojej firmy." />
            <section className="bg-[#06111F] text-white pt-32 pb-16 md:pt-40 md:pb-20 relative overflow-hidden">
                <div className="absolute inset-0 bg-grid-faint opacity-50" />
                <div className="relative max-w-4xl mx-auto px-5 md:px-8 text-center">
                    <div className="text-xs font-semibold tracking-widest uppercase text-[#14B8A6] mb-3">Pakiety</div>
                    <h1 className="font-display font-extrabold text-[38px] md:text-[58px] lg:text-[64px] leading-[1.05] tracking-tight">
                        Wybierz rozwiązanie dopasowane do<br /><span className="text-[#14B8A6]">etapu rozwoju Twojej firmy</span>
                    </h1>
                </div>
            </section>
            <Section variant="light">
                <div className="grid lg:grid-cols-3 gap-6 md:gap-8 items-stretch">
                    {packages.map((p) => (
                        <div key={p.slug} data-testid={`packages-page-${p.slug}`} className={`relative rounded-[20px] p-7 md:p-8 flex flex-col ${p.highlighted ? "border-2 border-[#14B8A6] bg-gradient-to-b from-white to-[#14B8A6]/[0.04] shadow-[0_30px_60px_-20px_rgba(20,184,166,0.35)] lg:scale-[1.03] z-10" : "border border-[#E5E7EB] bg-white"}`}>
                            {p.highlighted && (
                                <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-4 py-1 rounded-full bg-[#14B8A6] text-white text-xs font-semibold">{p.badge}</div>
                            )}
                            <h3 className="font-display font-semibold text-2xl md:text-3xl text-[#0B1220]">{p.name}</h3>
                            <div className="mt-2 text-[#14B8A6] font-display font-bold text-2xl">{p.priceFrom}</div>
                            <p className="mt-3 text-sm text-[#0B1220]/70 leading-relaxed">{p.description}</p>
                            <ul className="mt-6 space-y-3 text-[14px] text-[#0B1220]/80 flex-1">
                                {p.features.map((f) => (
                                    <li key={f} className="flex gap-2.5">
                                        <CheckCircle2 className="w-4 h-4 text-[#14B8A6] flex-shrink-0 mt-0.5" /><span>{f}</span>
                                    </li>
                                ))}
                            </ul>
                            <Link to={`/kontakt?package=${encodeURIComponent(p.name)}`} data-testid={`packages-page-cta-${p.slug}`} className={`mt-7 inline-flex items-center justify-center px-5 py-3 rounded-[12px] font-semibold text-sm transition-all hover:-translate-y-0.5 ${p.highlighted ? "bg-[#14B8A6] hover:bg-[#0EA5A5] text-white shadow-[0_10px_24px_-8px_rgba(20,184,166,0.55)]" : "border border-[#0B1220]/15 text-[#0B1220] hover:border-[#14B8A6] hover:text-[#14B8A6]"}`}>
                                {p.cta}
                            </Link>
                        </div>
                    ))}
                </div>
                <div className="mt-12 text-center">
                    <p className="text-[#0B1220]/70 mb-4">Nie widzisz rozwiązania dla siebie? Przygotujemy indywidualny zakres i wycenę.</p>
                    <SecondaryButton to="/kontakt?package=Indywidualny" testid="packages-page-custom-cta">Poproś o indywidualną wycenę</SecondaryButton>
                </div>
                <SocialPlanCard testidPrefix="packages-page-social-plan" />
            </Section>
        </>
    );
}
